import { TILE_TYPE } from '@/constants';

const getStandardPropertyFlightBadgeCode = (propertyId, campaigns) => {
  const activeCampaigns = campaigns?.filter(
    (campaign) => campaign.sashing !== null,
  );

  const flightPromotionCodes = [];

  activeCampaigns?.forEach((campaign) => {
    const activeCampaignStandardPropertyTiles = campaign?.tiles?.filter(
      (tile) => tile.type === TILE_TYPE.STANDARD_PROPERTY,
    );

    const targetTiles = activeCampaignStandardPropertyTiles?.filter(
      (tile) => tile.propertyId === propertyId,
    );

    targetTiles?.forEach((tile) => {
      if (tile?.sashing?.flightPromoCode) {
        flightPromotionCodes.push(tile.sashing.flightPromoCode);
      }
    });
  });

  return flightPromotionCodes[0];
};

export default getStandardPropertyFlightBadgeCode;
